export const NOTIFICATION_VARIANTS = {
  INFO: "info",
  ERROR: "error",
};
